module.exports = __webpack_public_path__ + "img/phones.d6836591.png";